<template>
  <el-container>
    <el-aside class="leftMenuContainer">
      <!--左侧工作区-->
      <el-col :span="24">
        <leftMenu activeIndex='5'></leftMenu>
      </el-col>
    </el-aside>
    <el-main class="work_container" id="witePage">
      <el-carousel :interval="5000" arrow="always" v-if="showBanner" height="170px">
        <!-- <el-carousel-item>
          <a href="javascript:void(0)">
            <div class="active active0"
                 @click="toBuy">
              <el-link :underline="false"
                       @click="closeBanner"
                       class="closeBtn">
              </el-link>
            </div>
          </a>
        </el-carousel-item> -->
        <el-carousel-item>
          <div class="active active1">
            <el-link :underline="false" @click="closeBanner" class="closeBtn">
            </el-link>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="active active2">
            <el-link :underline="false" @click="closeBanner" class="closeBtn">
            </el-link>
          </div>
        </el-carousel-item>
        <div style="clear: both;"></div>
      </el-carousel>

      <el-row>
        <el-col :span="12">
          <h3 class="t_l">AI写作</h3>
        </el-col>
        <!-- <el-col :span="12" class="t_r"><el-input v-model="writeType" placeholder="搜索写作类型" prefix-icon="el-icon-search"
            class="typeSearch"></el-input></el-col> -->
      </el-row>
      <el-row>
        <el-col :span="12" class="t_l">
          <el-radio-group v-model="writeType" size="small" class="writeType">
            <el-radio label="all" border>全部</el-radio>
            <el-radio label="hot" border>热点</el-radio>
            <el-radio label="finance" border>财经</el-radio>
            <el-radio label="car" border>汽车</el-radio>
            <el-radio label="text" border>导入</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="12" class="t_r">
          <div class="needHelp">
            <el-link :underline="false" type="primary" @click="adviceDialogVisible = true">我需要更多帮助</el-link>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'hot'" @click="titleDialogVisible = true">
            <div class="hot"></div>
            <div class="title">命题写作</div>
            <div class="NORMAL"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'hot'" @click="newsDialogVisible = true">
            <div class="hot"></div>
            <div class="title">资讯写作</div>
            <div class="SLIVER"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'hot'" @click="hotDialogVisible = true">
            <div class="hot"></div>
            <div class="title">热搜写作</div>
            <div class="SLIVER"></div>
          </div>
        </a>
        <a href="javascript:void(0)">

          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'finance'"
            @click="simpleDialogVisible = true">
            <div class="finance"></div>
            <div class="title">个股写作</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'finance'"
            @click="compareDialogVisible = true">
            <div class="finance"></div>
            <div class="title">股票组合写作</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'finance'"
            @click="conceptDialogVisible = true">
            <div class="finance"></div>
            <div class="title">概念写作</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'finance'"
            @click="genOpenCloseArticle('0')">
            <div class="finance"></div>
            <div class="title">开盘股评</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'finance'"
            @click="genOpenCloseArticle('1')">
            <div class="finance"></div>
            <div class="title">收盘股评</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'finance'"
            @click="genFinanceDefindArticle">
            <div class="finance"></div>
            <div class="title">自定义写作</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'car'"
            @click="chooseCarDialogVisible = true">
            <div class="car"></div>
            <div class="title">产品选购</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'car'"
            @click="descCarDialogVisible = true">
            <div class="car"></div>
            <div class="title">外观描述</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'car'"
            @click="newCarDialogVisible = true">
            <div class="car"></div>
            <div class="title">荐新车</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'car'"
            @click="carerSayDialogVisible = true">
            <div class="car"></div>
            <div class="title">车主说</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'car'"
            @click="argueBadDialogVisible = true">
            <div class="car"></div>
            <div class="title">怼差评</div>
            <div class="GOLD"></div>
          </div>
        </a>

        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'car'"
            @click="defindCarDialogVisible = true">
            <div class="car"></div>
            <div class="title">自定义写作</div>
            <div class="GOLD"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'text'"
            @click="importTextDialogVisible = true">
            <div class="text"></div>
            <div class="title">导入文本</div>
            <div class="SLIVER"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'text'"
            @click="importWorldDialogVisible = true">
            <div class="text"></div>
            <div class="title">导入word</div>
            <div class="SLIVER"></div>
          </div>
        </a>
        <a href="javascript:void(0)">
          <div class="writeTypeCard" v-if="writeType === 'all' || writeType === 'text'"
            @click="importImageDialogVisible = true">
            <div class="text"></div>
            <div class="title">导入图片</div>
            <div class="SLIVER"></div>
          </div>
        </a>
      </el-row>

    </el-main>

    <price v-if="priceListDialogVisible" :show=priceListDialogVisible />

    <el-dialog :visible.sync="titleDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <titleWriter />
    </el-dialog>

    <el-dialog :visible.sync="newsDialogVisible" custom-class="writeDialog" width="1045px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <newsWriter />
    </el-dialog>

    <el-dialog :visible.sync="hotDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :modal-append-to-body='false' :close-on-press-escape="false">
      <hotWriter />
    </el-dialog>

    <el-dialog :visible.sync="simpleDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <simpleWriter />
    </el-dialog>

    <el-dialog :visible.sync="compareDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <compareWriter />
    </el-dialog>

    <el-dialog :visible.sync="conceptDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <conceptWriter />
    </el-dialog>

    <el-dialog :visible.sync="newCarDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <newCarWriter />
    </el-dialog>

    <el-dialog :visible.sync="carerSayDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <carerSay />
    </el-dialog>

    <el-dialog :visible.sync="argueBadDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <argueBad />
    </el-dialog>

    <el-dialog :visible.sync="chooseCarDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <chooseCar />
    </el-dialog>

    <el-dialog :visible.sync="descCarDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <descCar />
    </el-dialog>

    <el-dialog :visible.sync="defindCarDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <defindCar />
    </el-dialog>

    <el-dialog :visible.sync="importTextDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <importText />
    </el-dialog>

    <el-dialog :visible.sync="importImageDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <importImage />
    </el-dialog>

    <el-dialog :visible.sync="importWorldDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <importWorld />
    </el-dialog>

    <el-dialog :visible.sync="adviceDialogVisible" custom-class="writeDialog" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <advice @close="adviceDialogVisible = false" />
    </el-dialog>

  </el-container>
</template>

<script>
import xyCard from '../components/xy_card'
import leftMenu from '../components/left_menu.vue'

import titleWriter from '../components/write/title.vue'
import hotWriter from '../components/write/hot.vue'
import newsWriter from '../components/write/news.vue'
import simpleWriter from '../components/write/simple.vue'
import compareWriter from '../components/write/compare.vue'
import conceptWriter from '../components/write/concept.vue'

import newCarWriter from '../components/write/newCar.vue'
import carerSay from '../components/write/carerSay.vue'
import argueBad from '../components/write/argueBad.vue'
import chooseCar from '../components/write/chooseCar.vue'
import descCar from '../components/write/descCar.vue'
import defindCar from '../components/write/defindCar.vue'
import importText from '../components/write/importText.vue'
import importImage from '../components/write/importImage.vue'
import importWorld from '../components/write/importWorld.vue'

import price from './price'
import * as appJs from '../assets/js/app'
import advice from '../components/advice.vue'
export default {
  name: 'title_',
  data: function () {
    return {
      keyMap: {},
      keyword: '',
      referIndex: 1,

      priceListDialogVisible: 0,
      articleId: '',
      isVip: false,
      showBanner: true,
      writeType: 'all',
      titleDialogVisible: false,
      newsDialogVisible: false,
      hotDialogVisible: false,
      adviceDialogVisible: false,
      simpleDialogVisible: false,
      compareDialogVisible: false,
      conceptDialogVisible: false,
      newCarDialogVisible: false,
      carerSayDialogVisible: false,
      argueBadDialogVisible: false,
      chooseCarDialogVisible: false,
      descCarDialogVisible: false,
      defindCarDialogVisible: false,
      importTextDialogVisible: false,
      importImageDialogVisible: false,
      importWorldDialogVisible: false,
      vipInfo: {}

    }
  },
  methods: {
    toBuy () {
      let code = ''
      if (this.vipInfo.vipLevel === 'GOLD') {
        code = 3002
      }
      if (this.vipInfo.vipLevel === 'SLIVER') {
        code = 3003
      }
      console.log(code)
      this.$store.commit('showPriceDialog', code);
    },
    genFinanceDefindArticle () {
      this.axios.get(`/webApi/v3/robot/stock/writeBlank`).then(resp => {
        this.$router.push({ path: '/newsEdit', query: { articleId: resp.data.autoNewsId, 'from': 'finance' } })
      })
    },

    genOpenCloseArticle (type) {
      this.axios.get(`/webApi/v3/robot/stock/openClose?marketStatus=${type}`).then(resp => {
        this.$router.push({ path: '/newsEdit', query: { articleId: resp.data.autoNewsId, 'from': 'finance' } })
      })
    },

    closeBanner () {
      this.showBanner = false;
      let dateStr = new Date().toLocaleDateString();
      let temp = {}
      temp[dateStr] = '1'
      localStorage.setItem('banner-show', JSON.stringify(temp))
    },
    openBuyDialog () {
      this.priceListDialogVisible++
    },
    toTxtExp () {
      this.$router.push({ path: '/txtExp' })
    },

    // 跳转到详情页
    goDetail (articleId) {
      if (articleId) {
        this.$router.push({ path: '/newsEdit', query: { articleId: articleId, 'from': 'title' } })
      } else {
        _this.$message.error('写作失败，请换个词试试');
      }
    },

    // 搜索关键词
    querySearchAsync (key, cb) {
      if (this.isVip) {
        let result = []
        if (!key) {
          cb(result)
          return
        }
        let tempKey = key.replace(/\s*/g, '')
        if (this.keyMap[tempKey]) {
          cb(this.keyMap[tempKey])
          return
        }

        let _this = this
        this.axios.post('/webApi/v3/hot/hot-tips-list?size=5&keyword=' + key, { '$noLoading': true }).then((response) => {
          response.data.forEach(e => {
            result.push({ 'value': _this.keyword, 'title': e.h_title || e.title, 'extValue': e.heightLightWordsStr, 'newsIds': e.newsIds })
          })
          cb(result)
          _this.keyMap[tempKey] = result
        })
      } else {
        cb(null)
      }
    },
    // 选择关键词
    handleSelect (val) {
      this.genArticleByKeyWord(val.newsIds)
    }

  },
  components: {
    xyCard,
    price,
    leftMenu,
    titleWriter,
    hotWriter,
    newsWriter,
    simpleWriter,
    compareWriter,
    conceptWriter,
    newCarWriter,
    carerSay,
    argueBad,
    chooseCar,
    descCar,
    defindCar,
    importText,
    importImage,
    importWorld,
    advice
  },
  mounted () {
    let _this = this
    let temp = JSON.parse(localStorage.getItem('banner-show') || '{}')
    this.showBanner = !temp[new Date().toLocaleDateString()]
    if (this.showBanner) {
      localStorage.removeItem('banner-show')
    }
    appJs.isVip().then(() => { this.isVip = true })
    appJs.getVip().then(data => {
      _this.vipInfo = data
    })
  },
  watch: {

  }
}
</script>
<style lang="less" scoped>
.work_container {
  padding: 20px;
}
</style>
<style lang="less">
#witePage {
  .active {
    width: 100%;
    background-repeat: no-repeat;
    height: 170px;
    position: relative;
    background-position: center;
    border-radius: 10px;
    background-size: cover;

    .closeBtn {
      background-image: url('../assets/imgs/writepage_icon.png');
      background-size: 200%;
      width: 24px;
      height: 24px;
      background-position: 0px -250px;
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }

  .active1 {
    background-image: url('../assets/imgs/activity.png');
  }

  .active2 {
    background-image: url('../assets/imgs/activity1.png');
  }

  .active0 {
    background-image: url('../assets/imgs/activity0.png');
  }

  .needHelp {
    width: 155px;
    font-size: 12px;
    color: #2a82e4;
    display: inline-block;
    background-size: 200%;
    vertical-align: middle;
  }

  .needHelp::before {
    content: ' ';
    background-image: url('../assets/imgs/writepage_icon.png');
    background-position: 0px -162px;
    background-repeat: no-repeat;
    width: 20px;
    height: 20px;
    display: inline-block;
    background-size: 200%;
    vertical-align: middle;
  }

  .writeTypeCard {
    border: 2px solid #eaedf0;
    color: black;
    height: 130px;
    width: 230px;
    background-color: white;
    border-radius: 10px;
    padding: 10px 15px;
    // box-sizing: border-box;
    vertical-align: middle;
    float: left;
    margin-right: 20px;
    margin-top: 20px;

    .title {
      font-size: 18px;
      // font-weight: 600;
      letter-spacing: 1px;
      height: 80px;
      vertical-align: middle;
      line-height: 80px;
    }

    .hot {
      background-image: url('../assets/imgs/writepage_icon.png');
      width: 24px;
      height: 24px;
      background-size: 200%;
    }

    .hot::after {
      content: '热点写作';
      width: 80px;
      font-size: 12px;
      display: inline-block;
      text-align: right;
    }

    .finance {
      background-image: url('../assets/imgs/writepage_icon.png');
      width: 24px;
      height: 24px;
      background-position: 0px -50px;
      background-size: 200%;
    }

    .finance::after {
      content: '财经写作';
      width: 80px;
      font-size: 12px;
      display: inline-block;
      text-align: right;
    }

    .car {
      background-image: url('../assets/imgs/writepage_icon.png');
      width: 24px;
      height: 24px;
      background-position: 0px -100px;
      background-size: 200%;
    }

    .car::after {
      content: '汽车写作';
      width: 80px;
      font-size: 12px;
      display: inline-block;
      text-align: right;
    }

    .text {
      background-image: url('../assets/imgs/writepage_icon.png');
      width: 24px;
      height: 24px;
      background-position: 0px -150px;
      background-size: 200%;
    }

    .text::after {
      content: '导入写作';
      width: 80px;
      font-size: 12px;
      display: inline-block;
      text-align: right;
    }

    .NORMAL {
      background-color: #d3e3f5;
      border-radius: 3px;
      width: 50px;
      height: 22px;
      display: inline-block;

      float: right;
    }

    .NORMAL::after {
      text-align: right;
      display: inline-block;
      color: #3c4258;
      font-size: 12px;
      border-radius: 5px;
      padding: 2px 0px;
      content: '免费';
      vertical-align: middle;
    }

    .GOLD::before {
      background-image: url('../assets/imgs/writepage_icon.png');
      content: ' ';
      background-position: 0px -184px;
      width: 15px;
      height: 15px;
      display: inline-block;
      vertical-align: middle;
      background-size: 200%;
    }

    .GOLD {
      background-image: linear-gradient(to bottom, #f0e1b8, #d4b380);
      border-radius: 3px;
      width: 50px;
      height: 22px;
      display: inline-block;

      float: right;
    }

    .GOLD::after {
      text-align: right;
      display: inline-block;
      color: #3c4258;
      font-size: 12px;
      border-radius: 5px;
      padding: 2px 0px;
      content: '黄金';
      vertical-align: middle;
    }

    .SLIVER::before {
      background-image: url('../assets/imgs/writepage_icon.png');
      content: ' ';
      background-position: 0px -184px;
      width: 15px;
      height: 15px;
      display: inline-block;
      vertical-align: middle;
      background-size: 200%;
    }

    .SLIVER {
      background-image: linear-gradient(to bottom, #f7f7f7, #d5d8de);
      display: inline-block;
      border-radius: 3px;
      width: 50px;
      height: 22px;
      float: right;
    }

    .SLIVER::after {
      text-align: right;
      display: inline-block;
      color: #3c4258;
      font-size: 12px;
      border-radius: 5px;
      padding: 2px 0px;
      content: '白银';
      vertical-align: middle;
    }
  }

  .writeTypeCard:hover {
    box-shadow: 0px 0px 6px 3px #f4f6fb;
  }

  .writeType {
    .is-checked {
      background-color: #e2e9fe !important;

      .el-radio {
        color: #2a82e4;
      }
    }

    .el-radio {
      margin-right: 10px;
      padding: 3px 7px !important;
      height: 40px;
      width: 70px;
      background-color: white;
      border: 1px solid #eaedf0;
      border-radius: 10px;
      text-align: center;

      .el-radio__input {
        display: none;
      }

      .el-radio__label {
        padding-left: 0px;
        line-height: 35px;
        font-size: 15px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/app/write.vue